<template>
  <div class="testv__loading__wrapepr">
    <transition name="testv__loading__fade">
      <div v-show="loading" class="testv__loading">
        <IconArrowDown class="icon__arrowDown"/>
        <span>{{ loadingText }}</span>
      </div>
    </transition>
    <transition name="testv__loading__fade">
      <div v-show="loadEnd && !noDataAvailable && loadEndText" class="testv__loading--end">
        <span>{{ loadEndText }}</span>
      </div>
    </transition>
    <transition name="testv__loading__fade">
      <div v-show="loadEnd && noDataAvailable && noDataAvailableText" class="testv__loading--none">
        <span>{{ noDataAvailableText }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'TestvLoading',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    loadingText: {
      type: String,
      default: 'LOAD MORE'
    },
    loadEnd: {
      type: Boolean,
      default: false
    },
    noDataAvailable: {
      type: Boolean,
      default: false
    },
    noDataAvailableText: {
      type: String,
      default: '暂无'
    },
    loadEndText: {
      type: String,
      default: 'END'
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/styles/variable.styl'
.testv__loading__wrapepr {
  position: relative;
  height: var(--height-TestvLoading, 112px);
  box-sizing: border-box;
  &::before,
  &::after {
    content: '';
    display: block;
    background-image: url("~@/assets/images/border.png")
    background-size: auto 100%;
    width: 100%;
    height: 2px;
    position: absolute;
    left: 0;
  }
  &::before {
    top: 0;
  }
  &::after {
    bottom: 0;
  }
}

.testv__loading {
  .icon__arrowDown {
    width: 32px;
    height: 32px;
  }
}

.testv__loading,
.testv__loading--end,
.testv__loading--none {
  color: var(--color-TestvLoadingText, var(--dark-bwb-3));
  font-size: var(--text-TestvLoadingText, 13px);
  line-height: var(--size-TestvLoading, 24px);
}

.testv__loading,
.testv__loading--end,
.testv__loading--none {
  display: flex;
  align-items: center;
  column-gap: 16px;
  font-family: "DottedSongtiSquare";
  font-size: 32px;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  height: 100%;
  padding: var(--padding-TestvLoading, (40px 0));
  box-sizing: border-box;
  background: var(--color-bg-TestvLoading, transparent);
}

.testv__loading__fade-enter-active,
.testv__loading__fade-leave-active {
  opacity: 1;
  transition: all $a-dur-default $a-func-default;
}

.testv__loading__fade-enter,
.testv__loading__fade-leave-to {
  opacity: 0
}
</style>
